export const POTENTIAL_CUSTOMERS_STATUS_ALL = 'all' // 全部
export const POTENTIAL_CUSTOMERS_STATUS_TODO = 1 // 待处理
export const POTENTIAL_CUSTOMERS_STATUS_PUSHED = 2 // 已推送
export const POTENTIAL_CUSTOMERS_STATUS_FINISHED = 3 // 成为客资
export const POTENTIAL_CUSTOMERS_STATUS_INVALID = 4 // 已过期

export const POTENTIAL_CUSTOMERS_STATUS = {
  [POTENTIAL_CUSTOMERS_STATUS_TODO]: '待处理',
  [POTENTIAL_CUSTOMERS_STATUS_PUSHED]: '已推送',
  [POTENTIAL_CUSTOMERS_STATUS_FINISHED]: '成为客资',
  [POTENTIAL_CUSTOMERS_STATUS_INVALID]: '已过期'
}

export const POTENTIAL_CUSTOMERS_STATUS_COLOR = {
  [POTENTIAL_CUSTOMERS_STATUS_TODO]: '#ffa632',
  [POTENTIAL_CUSTOMERS_STATUS_PUSHED]: '#0e9c25',
  [POTENTIAL_CUSTOMERS_STATUS_FINISHED]: '#448afc',
  [POTENTIAL_CUSTOMERS_STATUS_INVALID]: '#999'
}

export const POTENTIAL_CUSTOMERS_JUMP = {
  Package: `${
    window.location.host.indexOf('www') > -1
      ? '//m.hunliji.com'
      : '//mtest.hunliji.com'
  }/package/detail_`,
  Example: `${
    window.location.host.indexOf('www') > -1
      ? '//m.hunliji.com'
      : '//mtest.hunliji.com'
  }/example/detail_`
}
